import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import EsmsDialog from '../../components/EsmsDialog';

import { deleteDevices } from '../../actions/deviceActions';
import { enqueueSnackbar } from '../../actions/applicationMessageActions';

import { triggerInventoryScan } from '../../actions/inventoryActions';

import classes from './DeleteDeviceModal.module.css';

class DeleteDeviceModal extends Component {
    static defaultProps = {
        deleteDevices:        () => {},
        close:                () => {},
        open:                 false,
        triggerInventoryScan: () => {}
    };

    static propTypes = {
        companyInfo: shape({
            companyId: string.isRequired
        }),
        deleteDevices:        func,
        devices:              array.isRequired,
        close:                func,
        open:                 bool,
        triggerInventoryScan: func,
    };

    state = {
        formIsValid: false,
        isLoading:   false,
    }

    handleChange = event => {
        const formIsValid =
            event.target.value.toLowerCase() === 'delete';
        this.setState({ formIsValid });
    }

    handleDelete = async () => {
        const { companyInfo: { companyId }, devices, reroute, resetSelectState, selectedAgent } = this.props;
        try {
            this.setState({
                isLoading: true
            });
            const allDeleted =
                await this.props.deleteDevices(companyId, selectedAgent, devices);
            if (allDeleted) {
                if (!reroute) {
                    this.setState({
                        isLoading: false
                    });
                    resetSelectState();
                    this.handleClose();
                    return;
                }
                this.setState({
                    isLoading: false
                });
                resetSelectState();
                reroute();
            }
        } catch (error) {
            this.props.enqueueSnackbar(
                `An error has occurred: ${error.message}`,
                'error'
            );
        }
    }

    handleClose = () => {
        this.setState({
            formIsValid: false
        });

        this.props.close();
    }

    render() {
        let { open, devices } = this.props;

        return (
            <EsmsDialog
                open={open}
                onClose={this.handleClose}
                onConfirm={this.handleDelete}
                disabled={!this.state.formIsValid || this.state.isLoading}
                title={`Delete ${devices.length} device(s)`}
                confirmText="Delete"
            >
                <p>
                    Are you sure you want to delete these devices:
                </p>
                <div className={classes.listContainer}>
                    <ul>
                        {devices.map(({ id, name }) => (
                            <li key={id}>
                                {name}
                            </li>
                        ))}
                    </ul>
                </div>
                <p>
                    To confirm, please type the word <span className={classes.warning}>DELETE</span> in the field below.
                </p>
                <FormControl className={classes.fullWidth}>
                    <InputLabel
                        htmlFor="delete"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        Delete Confirmation
                    </InputLabel>
                    <Input
                        id="delete"
                        onKeyUp={this.handleChange}
                        name="delete"
                        classes={{
                            underline: classes.cssUnderline,
                            root:      classes.input
                        }}
                    />
                </FormControl>
            </EsmsDialog>
        );
    }
}

const mapStateToProps = ({ companyInfo, basAgent }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    return {
        companyInfo,
        selectedAgent
    };
};

const mapDispatchToProps = {
    enqueueSnackbar,
    deleteDevices,
    triggerInventoryScan
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDeviceModal);
